export default "__VITE_ASSET__dc3a335f__"